// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSConfig.custom.products_per_page,
		/* Optional */
		loadProductFirst: false,
		filterTreeMobileStyle: 'style1',
        capitalizeFilterOptionValues: false,
     	sortingAvailableFirst: true
	},
};

// Declare Templates
var boostPFSTemplate = {
	'soldOutClass': 'product--sold-out',
	'onSaleClass': 'product--sale',
	'soldOutLabelHtml': '<div class="product__label label label--light"><p class="product__label-text label__text">Sold out</p></div>',
	'saleLabelHtml': '<div class="product__label label label--brand"><p class="product__label-text label__text">Sale</p></div>',
	'newLabelHtml': '<div class="product__label label label--brand"><p class="product__label-text label__text">New</p></div>',
	'vendorHtml': '<h4 class="product__vendor h6">{{itemVendorLabel}}</h4>',	
	
	'productGridItemHtml': 	'<div class="o-layout__item u-1/'+ boostPFSConfig.custom.grid_mobile + ' ' + boostPFSConfig.custom.grid_item_width + '">' +
								'<div data-product="{{data}}" class="product js-product {{soldOutClass}} {{onSaleClass}} {{productDetailHoverClass}} {{productGridImgSize}} {{productGridAlign}}">' +
								
									'<div class="product-top">' +
										'<a href="{{itemUrl}}" class="product-link js-product-link" title="{{itemTitle}}" tabindex="-1">' +
											'<div class="product__media {{itemImageHoverClass}}">' +
												'{{itemImages}}' +
											'</div>' +
  											'{{itemLabels}}' +
										'</a>' +
										'{{itemQuickBuy}}' +
									'</div>' +
									'<a href="{{itemUrl}}" class="product-link js-product-link" title="{{itemTitle}}">' +
										'<div class="product__details">' +
											'<h3 class="product__title h4">{{itemTitle}}</h3>' +
											'{{itemVendor}}' +
											'<div class="product__details__hover">' +
												'{{itemPrice}}' +
  												'{{itemSizes}}' +
												'{{itemSwatch}}' +
												'{{itemReviews}}' +
											'</div>' +
										'</div>' +
									'</a>' +
								'</div>' +
							'</div>',

	// Pagination Template
	'previousHtml': '<span class="prev"><a href="{{itemUrl}}" title="Previous"><i class="icon icon--left-t"></i></a></span>',
	'nextHtml': '<span class="next"><a href="{{itemUrl}}" title="Next"><i class="icon icon--right-t"></i></a></span>',
	'pageItemHtml': '<span class="page"><a href="{{itemUrl}}" title="">{{itemTitle}}</a></span>',
	'pageItemSelectedHtml': '<span class="page current">{{itemTitle}}</span>',
	'pageItemRemainHtml': '<span class="deco">{{itemTitle}}</span>',
	'paginateHtml': '{{previous}}{{pageItems}}{{next}}',	
	// Sorting Template
	'sortingHtml': '<label for="boost-pfs-filter-top-sorting-select">' + boostPFSConfig.label.sorting + '</label><select class="boost-pfs-filter-top-sorting-select">{{sortingItems}}</select>',
};


(function () { 

	BoostPFS.inject(this); 
	/************************** BUILD PRODUCT LIST **************************/

	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function (data) {
		if (!data) data = this.data;
		
		/*** Prepare data ***/
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function (e) { return e.id == Utils.getParam('variant'); });
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/

		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;

		// Add soldOut class
		var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
      
      	var newData = escape(JSON.stringify(data));
        itemHtml = itemHtml.replace(/{{data}}/g,newData);
      
		// Add onSale class
		var onSaleClass = onSale ? boostPFSTemplate.onSaleClass : '';
		itemHtml = itemHtml.replace(/{{onSaleClass}}/g, onSaleClass);

		// Add imageHover class
		var itemImageHoverClass = (boostPFSConfig.custom.product_grid_second_hover && images.length > 1) ? 'product__media--hover' : '';
		itemHtml = itemHtml.replace(/{{itemImageHoverClass}}/g, itemImageHoverClass);

		// Add productDetailHover class
		var productDetailHoverClass = boostPFSConfig.custom.product_grid_detail_style == 'hover' ? 'product--details-hover' : '';
		itemHtml = itemHtml.replace(/{{productDetailHoverClass}}/g, productDetailHoverClass);

		// Add productGridImgSize class
		var productGridImgSizeClass = 'product--';
		if (boostPFSConfig.custom.product_grid_image_size.indexOf('crop') > -1) {
			productGridImgSizeClass += 'crop';
		} else if (boostPFSConfig.custom.product_grid_image_size.indexOf('fit') > -1) {
			productGridImgSizeClass += 'fit';
		} else {
			productGridImgSizeClass += 'natural';
		}
		itemHtml = itemHtml.replace(/{{productGridImgSize}}/g, productGridImgSizeClass);

		// Add productGridAlign class
		var productGridAlign = 'product--' + boostPFSConfig.custom.product_grid_align;
		itemHtml = itemHtml.replace(/{{productGridAlign}}/g, productGridAlign);

		// Add itemImages
		var itemImagesHtml = '';
		var productRatio = '';
		var imagePadding = '';
		var gridImageSize = boostPFSConfig.custom.product_grid_image_size;
		var imageSrc = Utils.getFeaturedImage(images, '1x1').replace('_1x1.', '_520x.');
		if (gridImageSize == 'natural') {
			productRatio = 'custom';
			imagePadding = images.length > 0 ? Math.round(images[0].height / images[0].width * 100) : 100;
			imagePadding = 'style="padding-bottom:' + imagePadding + '%"';
		} else if (gridImageSize == 'fit-square' || gridImageSize == 'crop-square') {
			productRatio = '1:1';
		} else if (gridImageSize == 'fit-short' || gridImageSize == 'crop-short') {
			productRatio = '4:3';
		} else if (gridImageSize == 'fit-tall' || gridImageSize == 'crop-tall') {
			productRatio = '2:3';
		}

		itemImagesHtml += '<div class="o-ratio o-ratio--' + productRatio + '" ' + imagePadding +'>';
		itemImagesHtml += '<div class="o-ratio__content">';
		itemImagesHtml += '<div class="theme-spinner"></div>';
		if (boostPFSConfig.custom.product_grid_second_hover && images.length > 1) {
			itemImagesHtml += '<div class="product__img-hover img-lazyload lazyload js" ' +
				'data-bgset="' + bgset(images[1]) + '" ' +
				'data-sizes="auto" data-parent-fit="cover"></div>';
		}
		itemImagesHtml += '<img class="product__img img-lazyload lazyload js" ' +
			'data-src="' + imageSrc + '" data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512]" ' +
			'data-sizes="auto" alt="{{itemTitle}}">';
		itemImagesHtml += '</div>';
		itemImagesHtml += '</div>';
		itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);


		// Add Vendor
		var itemVendorHtml = boostPFSConfig.custom.product_grid_vendor ? boostPFSTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor) : '';
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

		// Add Price
		var itemPriceHtml = '';
		if (boostPFSConfig.custom.product_grid_price){
			itemPriceHtml += '<p class="product__price h5">';
			if (!soldOut) {
				if (onSale) {
					if (priceVaries) {
						itemPriceHtml += '<span class="product__price-price"><span class="money">' + Utils.formatMoney(data.price_min) + '</span></span>';
						itemPriceHtml += '<strike class="product__price-cross"><span class="money">' + Utils.formatMoney(data.compare_at_price_min) + '</span></strike>';
					} else {
						itemPriceHtml += '<span class="product__price-price"><span class="money">' + Utils.formatMoney(data.price_min) + '</span></span>';
						itemPriceHtml += '<strike class="product__price-cross"><span class="money">' + Utils.formatMoney(data.compare_at_price_min) + '</span></strike>';
					}
				} else {
					itemPriceHtml += '<span class="product__price-price"><span class="money">' + Utils.formatMoney(data.price_min) + '</span></span>';
                  if (priceVaries) itemPriceHtml += '<span> - </span><span class="product__price-price"><span class="money">' + Utils.formatMoney(data.price_max) + '</span></span>';
				}
			} else {
				itemPriceHtml += '<span class="product__price-price product__price-price--sold">' + boostPFSConfig.label.sold_out + '</span>';
			}
			itemPriceHtml += '</p>';
		}	
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);


		// Add label 
		var itemLabelsHtml = '';
		var customLabel = false;
		var newLabel = false;

		if (boostPFSConfig.custom.product_grid_label) {
			if (boostPFSConfig.custom.product_grid_label_collection != '') {
				for (var i = 0; i < data.collections.length; i++) {
					if (data.collections[i]['handle'] == boostPFSConfig.custom.product_grid_label_collection) {
						customLabel = true;
						break;
					}
				}
			}

			var dateNow = boostPFSConfig.custom.date_now;
			var dateCreatedAt = Date.parse(data.created_at) / 1000;
			var timeAgo = (dateNow - dateCreatedAt) / 86400;
			if (timeAgo < boostPFSConfig.custom.product_grid_label_new_days) {
				newLabel = true;
			}

			if (soldOut) {
				itemLabelsHtml += boostPFSTemplate.soldOutLabelHtml;
			} else if (customLabel) {
				itemLabelsHtml += '<div class="product__label label label--brand">';
				itemLabelsHtml += '<p class="product__label-text label__text">' + boostPFSConfig.label.product_grid_label_title + '</p>';
				itemLabelsHtml += '</div>';
			} else if (onSale) {
				itemLabelsHtml += '<div class="product__label label label--brand">';
				if (boostPFSConfig.custom.product_grid_label_sale_style == 'text') {
					itemLabelsHtml += '<p class="product__label-text label__text">' + boostPFSConfig.label.on_sale + '</p>';
				} else {
					itemLabelsHtml += ' <p class="product__label-text label__text">-' + data.percent_sale_min + '</p>';
				}
				itemLabelsHtml += '</div>';
			} else if (newLabel && boostPFSConfig.custom.product_grid_label_new) {
				itemLabelsHtml += '<div class="product__label label label--brand">';
				itemLabelsHtml += '<p class="product__label-text label__text">' + boostPFSConfig.label.new + '</p>';
				itemLabelsHtml += '</div>';
			}
          
           

            if(Utils.getProductMetafield(data,'Offer', 'promo_text') !== null) {
             
              var product_offers = Utils.getProductMetafield(data,'Offer', 'promo_text');
              product_offers = product_offers.split('||');
              
              if (product_offers.length > 0) {
                itemLabelsHtml += '<div class="product-offer-count">';
                if(product_offers.length == 1) {
                  itemLabelsHtml += '<strong class="label__text">'+ product_offers.length + ' Offer</strong>';
                } else {
                  itemLabelsHtml += '<strong class="label__text">'+ product_offers.length + ' Offers</strong>';
                }
                itemLabelsHtml += '</div>';
              }
            }
          
            
            var bestsellerFlag = Utils.getProductMetafield(data,'BestSeller flag', 'bestseller_flag')
            if (bestsellerFlag !== null) {
              if (bestsellerFlag > 0) {
                itemLabelsHtml += '<div class="product-best-seller-flag">';
                if (bestsellerFlag == 1) itemLabelsHtml += '<strong class="label__text">Bestseller</strong>';
                itemLabelsHtml += '</div>';
              }
            }
          
            var exclusiveFlag = Utils.getProductMetafield(data,'Exclusive Flag', 'exclusive_flag')
            if (exclusiveFlag !== null) {
              if (exclusiveFlag > 0) {
                itemLabelsHtml += '<div class="product-exclusive-flag">';
                if (exclusiveFlag == 1) itemLabelsHtml += '<strong class="label__text">Exclusive</strong>';
                itemLabelsHtml += '</div>';
              }
            }
          
            var limitedFlag = Utils.getProductMetafield(data,'Limited Edition', 'limited_edition_flag')
            if (limitedFlag !== null) {
              if (limitedFlag > 0) {
                itemLabelsHtml += '<div class="product-limited-flag">';
                if (limitedFlag == 1) itemLabelsHtml += '<strong class="label__text">Limited Edition</strong>';
                itemLabelsHtml += '</div>';
              }
            }

          
        }
        itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabelsHtml);
          

		// Add swatch
		var itemSwatch = buildSwatch(data);
		itemHtml = itemHtml.replace(/{{itemSwatch}}/g, itemSwatch);

		// Add Reviews
		if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
			var itemReviews = '';
			if (boostPFSConfig.custom.product_reviews){
				itemReviews = '<div class="product__reviews"><span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span></div>';
			}
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviews);
		}
		
		// Add item QuickBuy
		var itemQuickBuyHtml = '';
		if (boostPFSConfig.custom.product_grid_quick_buy != 'disabled') {
			itemQuickBuyHtml += '<div class="product-btn product-btn--' + boostPFSConfig.custom.product_grid_quick_buy + '">';
			if (soldOut) {
				itemQuickBuyHtml += '<a href="{{itemUrl}}" class="c-btn c-btn--full c-btn--light c-btn--small-tab product-btn__btn">' + boostPFSConfig.label.sold_out + '</a>';
			} else if (data.variants.length > 1) {
				itemQuickBuyHtml += '<a href="{{itemUrl}}" class="c-btn c-btn--full c-btn--primary c-btn--arrow c-btn--small-tab product-btn__btn">' + boostPFSConfig.label.select_options + '</a>';
			} else {
				itemQuickBuyHtml += '<form method="post" action="/cart/add" id="product_form_{{itemId}}" accept-charset="UTF-8" class="js-product-form" enctype="multipart/form-data">';
				itemQuickBuyHtml += '<input type="hidden" name="form_type" value="product">';
				itemQuickBuyHtml += '<input type="hidden" name="utf8" value="✓">';
				itemQuickBuyHtml += '<input type="hidden" name="id" value="' + firstVariant.id + '" />';
				itemQuickBuyHtml += '<button type="submit" name="add" class="c-btn c-btn--full c-btn--plus c-btn--primary c-btn--small-tab product-btn__btn js-product-add">';
				itemQuickBuyHtml += '<span class="js-product-add-text">' + boostPFSConfig.label.add_to_cart + '</span>';
				itemQuickBuyHtml += '</button>';
				itemQuickBuyHtml += '</form>';
			}
			itemQuickBuyHtml += '</div>';
		}
		itemHtml = itemHtml.replace(/{{itemQuickBuy}}/g, itemQuickBuyHtml);
      
     	itemHtml = itemHtml.replace(/{{itemSizes}}/g, buildItemSizes(data));
      

		// Add main attribute (Always put at the end of this function)
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

		return itemHtml;
	};
  
    function buildItemSizes(data){
  		var sizesHtml = '';
      if (data.variants && data.variants.length > 1 && data.options_with_values[0].name == 'size') {
       	sizesHtml = '<span class="swatch-view-more"> Shop ' + data.variants.length + ' sizes </span>';
      }
      	return sizesHtml
  
    }

	function buildSwatch(data){
		var html = '';
		var swatchItems = [];
		if (boostPFSConfig.custom.product_grid_swatch){
			var colorKeys = ['color', 'colour'];
			var colorValues = [];
			data.variants.forEach(function(variant){
				var colorValue = null;
				variant.merged_options.forEach(function(merged_option){
					var key = merged_option.split(':')[0].toLowerCase();
					var value = merged_option.split(':')[1].toLowerCase();
					if (colorKeys.indexOf(key) != -1 && colorValues.indexOf(value) == -1){
						colorValues.push(value);
						colorValue = value;
					}
				})
				if (colorValue){
					var slugifyColor = Utils.slugify(colorValue);
                  	var sku = variant.sku;
					var backgroundImage = boostPFSAppConfig.general.asset_url.split('boost-pfs.js?')[0] + slugifyColor + '---' + sku +'.jpg';
					var backgroundColor = slugifyColor.replace('-', '');
					
					var swatchItem = 	'<li class="product__swatch__item js-product-swatch-item o-list-inline__item" '+
											'data-variant-image="{{variantImage}}" '+
											'data-variant-url="{{variantUrl}}">' +
												'<span class="product__swatch__graphic {{whiteBorderClass}}" '+
													'style="background-color: {{backgroundColor}}; '+
													'background-image: url({{backgroundImage}})">'+
												'</span>' +											
												'<span class="u-hidden-visually">{{colorValue}}</span>' +
										'</li>';
					swatchItem = swatchItem.replace(/{{variantImage}}/g, variant.image ? variant.image : data.images_info[0].src);
					swatchItem = swatchItem.replace(/{{variantUrl}}/g, '{{itemUrl}}?variant=' + variant.id);
					swatchItem = swatchItem.replace(/{{whiteBorderClass}}/g, colorValue.toLowerCase().trim() == 'white' ? 'product__swatch__graphic--white' : '');
					swatchItem = swatchItem.replace(/{{backgroundColor}}/g, backgroundColor);
					swatchItem = swatchItem.replace(/{{backgroundImage}}/g, backgroundImage);
					swatchItem = swatchItem.replace(/{{colorValue}}/g, colorValue);
					swatchItems.push(swatchItem);
				}
			});
			if (swatchItems.length > 0){
				html = '<div class="product__swatch"><ul class="product__swatch__items o-list-inline">' + swatchItems.join(' ') + '</ul></div>';
			}
		}
		return html;
	}

	function bgset(image) {
		var bgset = '';
		if (image) {
			var aspect_ratio = image.width / image.height;

			if (image.width > 180) bgset += ' ' + Utils.optimizeImage(image.src, '180x') + ' 180w ' + Math.round(180 / aspect_ratio) + 'h,';
			if (image.width > 360) bgset += ' ' + Utils.optimizeImage(image.src, '360x') + ' 360w ' + Math.round(360 / aspect_ratio) + 'h,';
			if (image.width > 540) bgset += ' ' + Utils.optimizeImage(image.src, '540x') + ' 540w ' + Math.round(540 / aspect_ratio) + 'h,';
			if (image.width > 720) bgset += ' ' + Utils.optimizeImage(image.src, '720x') + ' 720w ' + Math.round(720 / aspect_ratio) + 'h,';
			if (image.width > 900) bgset += ' ' + Utils.optimizeImage(image.src, '900x') + ' 900w ' + Math.round(900 / aspect_ratio) + 'h,';
			if (image.width > 1080) bgset += ' ' + Utils.optimizeImage(image.src, '1080x') + ' 1080w ' + Math.round(1080 / aspect_ratio) + 'h,';
			if (image.width > 1296) bgset += ' ' + Utils.optimizeImage(image.src, '1296x') + ' 1296w ' + Math.round(1296 / aspect_ratio) + 'h,';
			if (image.width > 1512) bgset += ' ' + Utils.optimizeImage(image.src, '1512x') + ' 1512w ' + Math.round(1512 / aspect_ratio) + 'h,';
			if (image.width > 1728) bgset += ' ' + Utils.optimizeImage(image.src, '1728x') + ' 1728w ' + Math.round(1728 / aspect_ratio) + 'h,';
			if (image.width > 1950) bgset += ' ' + Utils.optimizeImage(image.src, '1950x') + ' 1950w ' + Math.round(1950 / aspect_ratio) + 'h,';
			if (image.width > 2100) bgset += ' ' + Utils.optimizeImage(image.src, '2100x') + ' 2100w ' + Math.round(2100 / aspect_ratio) + 'h,';
			if (image.width > 2260) bgset += ' ' + Utils.optimizeImage(image.src, '2260x') + ' 2260w ' + Math.round(2260 / aspect_ratio) + 'h,';
			if (image.width > 2450) bgset += ' ' + Utils.optimizeImage(image.src, '2450x') + ' 2450w ' + Math.round(2450 / aspect_ratio) + 'h,';
			if (image.width > 2700) bgset += ' ' + Utils.optimizeImage(image.src, '2700x') + ' 2700w ' + Math.round(2700 / aspect_ratio) + 'h,';
			if (image.width > 3000) bgset += ' ' + Utils.optimizeImage(image.src, '3000x') + ' 3000w ' + Math.round(3000 / aspect_ratio) + 'h,';
			if (image.width > 3350) bgset += ' ' + Utils.optimizeImage(image.src, '3350x') + ' 3350w ' + Math.round(3350 / aspect_ratio) + 'h,';
			if (image.width > 3750) bgset += ' ' + Utils.optimizeImage(image.src, '3750x') + ' 3750w ' + Math.round(3750 / aspect_ratio) + 'h,';
			if (image.width > 4100) bgset += ' ' + Utils.optimizeImage(image.src, '4100x') + ' 180w ' + Math.round(4100 / aspect_ratio) + 'h,';
			bgset += ' ' + image.src + ' ' + image.width + 'w ' + image.height + 'h,';
		}
		return bgset;
	}

	/************************** END BUILD PRODUCT LIST **************************/

	ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

		if (totalPage > 1) {
			var paginationHtml = boostPFSTemplate.paginateHtml;

			// Build Previous
			var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousHtml : '';
			previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
			paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

			// Build Next
			var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextHtml : '';
			nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
			paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

			// Create page items array
			var beforeCurrentPageArr = [];
			for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
				beforeCurrentPageArr.unshift(iBefore);
			}
			if (currentPage - 4 > 0) {
				beforeCurrentPageArr.unshift('...');
			}
			if (currentPage - 4 >= 0) {
				beforeCurrentPageArr.unshift(1);
			}
			beforeCurrentPageArr.push(currentPage);

			var afterCurrentPageArr = [];
			for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
				afterCurrentPageArr.push(iAfter);
			}
			if (currentPage + 3 < totalPage) {
				afterCurrentPageArr.push('...');
			}
			if (currentPage + 3 <= totalPage) {
				afterCurrentPageArr.push(totalPage);
			}

			// Build page items
			var pageItemsHtml = '';
			var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
			for (var iPage = 0; iPage < pageArr.length; iPage++) {
				if (pageArr[iPage] == '...') {
					pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
				} else {
					pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
				}
				pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
				pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
			}
			paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

			return paginationHtml;
		}

		return '';
	};

	/************************** BUILD TOOLBAR **************************/

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function () {
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {

			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
				}
				var html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
				return html;
			}
		}
	};

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function (data, eventType) { 
    	if(!data) data = this.data;
      	if(!eventType) eventType = this.eventType;
      
      	// Get sort and filter data
      	//console.log(Globals.queryParams.sort);
      	// End Get sort and filter data
      var customer_id = boostPFSThemeConfig.custom.customer.id
      var customer_type = customer_id != null ? 'registered_user' : 'guest';
      if(eventType=='sort') {
        console.log("sorting triggered")
        window.dataLayer.push({
          event: 'sort',
            customerID: customer_id,
            customer_type: customer_type,
            sort_type: Globals.queryParams.sort
        });

      }
      
    };

	// Build additional elements
	FilterResult.prototype.afterRender = function (data) {
		if (!data) data = this.data;
      
     	
		// Build filter button text
		var numSelectedFilter = jQ('.boost-pfs-filter-tree .boost-pfs-filter-selected-items .boost-pfs-filter-option-label').length;
		if (numSelectedFilter){
			jQ('.js-collection-draw-trigger').html(boostPFSConfig.label.filter + ' (' + numSelectedFilter + ')');
		} else {
			jQ('.js-collection-draw-trigger').html(boostPFSConfig.label.filter);
		}
      
      	///
      var count = '(' + filterCount() + ')';

          if (filterCount() > 0) jQ('.collection-main__filter-btn').attr('data-count', count);
          else jQ('.collection-main__filter-btn').removeAttr('data-count');
         

		if (window.SPR) {
			SPR.initDomEls();
			SPR.loadBadges();
		}

		// Call theme function
		if (window.sr && typeof window.sr.reveal == 'function'){
			sr.reveal('.product-top');
		}
		if (window.theme){	
			if (typeof window.theme.selectWrapper == 'function') theme.selectWrapper();
			if (typeof window.theme.ajaxCartInit == 'function') theme.ajaxCartInit();		
			if (typeof window.theme.productCollSwatch == 'function') theme.productCollSwatch();
		}
	};
  
    FilterMobileButton.prototype.afterRender = function() {
          var count = filterCount();
          if (count > 0) this.$element.attr('data-count', count);
          else this.$element.removeAttr('data-count');
    }

        // Customize Filter option label: Remove prefix, Captialize,...
    FilterOptionItem.prototype.beforeRender = function() {
        var label = this.label;
        if(label.toLowerCase().indexOf('l2_category') !== -1) this.label = label.replace('l2_category', '');
        if(label.toLowerCase().indexOf('collection_filter') !== -1) this.label = label.replace('collection_filter', '');
        if(label.toLowerCase() === 'extrait de parfum') {
            this.label = 'Extrait de Parfum';
        }
        
         if(label.toLowerCase() === 'wellness and accessories') {
            this.label = 'Wellness and Accessories';
        }
        if(label.toLowerCase() === 'eau de parfum') {
            this.label = 'Eau de Parfum';
        }
        if(label.toLowerCase() === 'eau de toilette') {
            this.label = 'Eau de Toilette';
        }
        if(label.toLowerCase() === 'eau de cologne') {
            this.label = 'Eau de Cologne';
        }
        
        if(label.toLowerCase() === 'bkr water bottle') {
            this.label = 'bkr Water Bottle';
        }
        if(label.toLowerCase() === 'diptyque') {
            this.label = label.toLowerCase();
        }
        if(label.toLowerCase() === 'acqua di parma') {
            this.label = 'Acqua di Parma';
        }

      
      // return label
      return label;
    };
  
  	FilterOptionItem.prototype.onClick = function(event) {
		if (event) {
			event.preventDefault();
		}
//       	console.log('Filter onClick:',this.parent.label);
//         console.log(':',this.value);
       var customer_id = boostPFSThemeConfig.custom.customer.id
       var customer_type = customer_id != null ? 'registered_user' : 'guest';
        window.dataLayer.push({
            event: 'filter',
              customerID: customer_id,
              customer_type: customer_type,
              filter_type: this.parent.label,
              filter_detail: this.value
          });

		if (!this.isDisabled()) {
			if (this.requestInstantly || this.parent.filterType == FilterOptionEnum.FilterType.COLLECTION) {
				this.onApplyFilter();
			} else {
				this.onSelectFilter();
			}
		}
	}
  
    function filterCount() {
            if (!Globals.hasFilterOptionParam) return 0

            var count = 0;

            Object.keys(Globals.queryParams).forEach(function(param) {
              if (param.indexOf('pf_') === 0) {
                if (Array.isArray(Globals.queryParams[param])) count += Globals.queryParams[param].length;
                else count++;
              }
            });

            return count;
     }
          

   
	function reinitScrollbar() {
  		// Re-init scrollbar in filter
    	if (typeof SimpleBar == 'function'){
    		jQ('[data-simplebar]').each(function(i, element){
    			var simpleBar = new SimpleBar(element);
    			simpleBar.recalculate();
    		})
		}
  	}

  	jQ('.js-collection-draw-trigger').on('click', function(){
  		setTimeout(reinitScrollbar, 500);
    });
  
    jQ(document).on('click','.o-layout__item .js-product',function(){
      var productAttData = jQ(this).data('product');
      var productJsonStringData = unescape(productAttData);
	  var productJsonObject = JSON.parse(productJsonStringData);
      var customer_id = boostPFSThemeConfig.custom.customer.id
      var variant = productJsonObject.variants[0].title
      var price = productJsonObject.variants[0].price
      var tag_array = productJsonObject.tags
      var l1_category = '',
          l2_category = '',
          l3_category = '';
      for (var i = 0; i < tag_array.length; i++) {
          if (tag_array[i].includes('l1_category')) {
              var temp = tag_array[i]
              var temp_replace = temp.replace('l1_category', '');
              l1_category = temp_replace
          }
          if (tag_array[i].includes('l2_category')) {
              var temp = tag_array[i]
              var temp_replace = temp.replace('l2_category', '');
              l2_category = temp_replace
          }
          if (tag_array[i].includes('l3_category')) {
              var temp = tag_array[i]
              var temp_replace = temp.replace('l3_category', '');
              l3_category = temp_replace
          }
      }
      var customer_type = customer_id != null ? 'registered_user' : 'guest';
      window.dataLayer.push({
          event: 'view_item',
          customerID: customer_id, 
          customer_type: customer_type,
          view_type: 'product_detail',
          ecommerce: {
              items: [{

                  item_id: productJsonObject.id,
                  item_name: productJsonObject.title,
                  item_brand: productJsonObject.vendor,
                  item_category: l1_category,
                  item_category2: l2_category,
                  item_category3: l3_category,
                  item_variant: variant,
                  price: price
              }]
          }
      });
      
          
      



    });

})();  